import React from "react";

const MertShop = () => {
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          projects {"> "}
          <i className="fa-solid fa-folder"> </i>
          mertShop
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">MertShop</div>
    </div>
  );
};

export default MertShop;
